import axios from "axios";
import { Message } from "element-ui";

const setBaseURL = (url) => {
  if (process.env.NODE_ENV === "development" && url.startsWith("jxsw/api")) {
    return "http://10.200.0.25:9012/";
  }
  return process.env.VUE_APP_SERVER+"/";
};
const setToken = (url) => {
  const token = JSON.parse(localStorage.getItem("userToken"));
  if (process.env.NODE_ENV === "development") {
    if (url.startsWith("jxsw/api")) {
      return token.jxsw;
    } else {
      return token.rhenium;
    }
  }
  return "";
};
const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
  (res) => {
    if (res.request.status !== 200) {
      return res.message;
    } else if (res.data.errors) {
      Message({
        message: res.data.errors[0].message,
        type: "error",
      });
      return Promise.reject();
    } else {
      return res.data.data;
    }
  },
  (error) => {
    const { response } = error;
    if (!response) {
      Message({
        message: error.message,
        type: "error",
      });

      return Promise.reject(error);
    }
    switch (response.status) {
      case 404:
        {
          Message({
            message: "未找到服务！",
            type: "error",
          });
        }
        break;
      default:
        Message({
          message: response.message,
          type: "error",
        });
    }

    return Promise.reject(error);
  }
);

const instance = {
  // 创建一个方法来发送请求
  request: async (method, url, options = {}) => {
    // 动态设置 baseURL
    const baseURL = setBaseURL(url);
    // 动态设置 token
    const token = setToken(url);
    try {
      // 发送请求
      return await axiosInstance({
        method: method,
        url: url,
        baseURL: baseURL,
        headers: {
          Authorization: token,
        },
        ...options,
      });
    } catch (error) {
      console.error(
        `Error with ${method.toUpperCase()} request to ${url}:`,
        error
      );
      throw error;
    }
  },
  get: (url, options) => instance.request("get", url, options),
  post: (url, data, options) =>
    instance.request("post", url, { data, ...options }),
  put: (url, data, options) =>
    instance.request("put", url, { data, ...options }),
  delete: (url, options) => instance.request("delete", url, options),
};
export default instance;
